// extracted by mini-css-extract-plugin
export default {"cls1":"auc9HdIGSHATGs4a8L6M","cls2":"GFzhhbWt2llFdRZJOe_y auc9HdIGSHATGs4a8L6M","gradientCard":"ckHrLdHI0leyOaPrWofh"};